import { makeVar } from '@apollo/client';

export const operationsSearch = makeVar({});
